<template>
    <DCard
        padding
    >
        <DTable
            :items="paymentTerms"
            :fields="[
                {key: 'payment_term', label: __('settings.payment_terms.form.payment_term')},
                {key: 'is_default', label: __('settings.payment_terms.form.default'), sorter: true, filter: false},
                {key: 'actions', label: '', sorter: false, filter: false}
            ]"
            hover
            sorter
        >
            <template #is_default="{item}">
                <td>
                    <DBadge :color="item.is_default ? 'success' : 'danger'">
                        {{
                            item.is_default ? __('settings.payment_terms.is_default.yes') : __('settings.payment_terms.is_default.no')
                        }}
                    </DBadge>
                </td>
            </template>
            <template #actions="{item}">
                <td>
                    <div style="display: flex; grid-gap: 10px;">
                        <DButton
                            :id="`edit_${item.id}`"
                            icon="pencil"
                            mini
                            @click="router.get(editPaymentTermLink(item.payment_term))"
                        />
                        <DButton
                            :id="`make-default-${item.id}`"
                            mini
                            icon="check-circle-outline"
                            :label="__('messages.actions.makeDefault')"
                            :disabled="item.is_default || isInLoadingState"
                            @click="handleChangeDefault(item.payment_term)"
                        />
                        <DButton
                            :id="`btn-delete-${item.id}`"
                            icon="trash-can-outline"
                            color="danger"
                            mini
                            :disabled="isInLoadingState"
                            @click="handeDeleteClick(item.payment_term)"
                        />
                    </div>
                </td>
            </template>
        </DTable>

        <DFabs>
            <DFab
                id="btn-add"
                icon="plus"
                :label="__('settings.payment_terms.add_button')"
                @click="handleCreate"
            />
        </DFabs>

        <DModal
            v-model:show="showMakeDefaultConfirmationModal"
            :title="__('settings.payment_terms.make_default_modal.title')"
            :message="__('settings.payment_terms.make_default_modal.message')"
            is-confirm
            @close="showMakeDefaultConfirmationModal = false"
            @confirm="makeDefaultPaymentTerm"
        />

        <DModal
            v-model:show="showConfirmationModal"
            :title="__('settings.payment_terms.delete_confirm_modal.title')"
            :message="__('settings.payment_terms.delete_confirm_modal.message')"
            is-confirm
            is-error
            @close="showConfirmationModal = false"
            @confirm="deletePaymentTerm"
        />
    </DCard>
</template>

<script>
import App from '~@/App.vue'
import { ref } from 'vue'
import { router } from '@inertiajs/vue3'
import { route } from '~@/Composables/route'
import LovLayout from '~@/Pages/Settings/Lov/LovLayout.vue'
import { __ } from '~@/Composables/translation'

export default {
    layout: [App, LovLayout]
}
</script>

<script setup>
defineProps({
    paymentTerms: {
        type: Array,
        default: () => { return [] }
    },
    errors: {
        type: Object,
        default: () => { return {} }
    }
})

const showConfirmationModal = ref(false)
const selectedItem = ref(null)
const showMakeDefaultConfirmationModal = ref(false)

function editPaymentTermLink (id) {
    return route('settings.payment-terms.edit', { paymentTerm: id })
}
function handeDeleteClick (id) {
    selectedItem.value = id
    showConfirmationModal.value = true
}

function deletePaymentTerm () {
    router.delete(route('settings.payment-terms.destroy', selectedItem.value))
    showConfirmationModal.value = false
}
function handleCreate () {
    router.get(route('settings.payment-terms.create'))
}

function handleChangeDefault (id) {
    selectedItem.value = id
    showMakeDefaultConfirmationModal.value = true
}

function makeDefaultPaymentTerm () {
    router.post(route('settings.payment-terms.make-default', selectedItem.value))
    showMakeDefaultConfirmationModal.value = false
}
</script>
